import Model from '../model';
import { CREATE_FEEDBACK } from 'api/graphql/feedback';
import { sanitize } from 'api/utils';

const types = {
    contacts: String,
    description: String,
    name: String
}

export const createFeedback = async (variables) => {
    const feedbackVariables = {
        ...variables,
        contacts: variables.customerPhone
    }
    return Model.apollo.mutate({
        mutation: CREATE_FEEDBACK,
        variables: sanitize(feedbackVariables, types)
    }).then((response) => {
        const feedbackId = response['data']?.['createFeedback']?.['feedback']?.['id'];
        return {
            feedbackId
        }
    });
}
